import { useProcessingUrl } from 'components/payment/payment.new.hooks';
import { useHistory } from 'react-router-dom';

// The web checkout 3DS2 modal never runs inside a native app WebView (that's
// the legacy-SDK-only /payments/threeds2verification route's job), so this
// only ever needs the redirect branch of the legacy useOn3DSStatusUpdates.
export const useOn3DSCheckoutSdkStatusUpdates = handleClose => {
  const history = useHistory();
  const processingUrl = useProcessingUrl();

  return threeDsStatusEvent => {
    if (threeDsStatusEvent.action !== 'challenge') {
      handleClose();
      history.push(processingUrl);
    }
  };
};
